/* Kaufknopf 12.10.2026 (Theme-Kopie PMP KAUFKNOPF 1210).
   Solange teeinblue das Kundenbild verarbeitet (Upload, Portrait wird erstellt, Bild n von m wird verarbeitet),
   ist der Kaufknopf sichtbar ausgegraut und trägt den Text "Dein Bild wird vorbereitet …".
   Ein Klick in dieser Zeit wird abgefangen und zeigt "Einen Moment noch, dein Bild wird gerade vorbereitet."
   statt der Pflichtfeld-Meldung von teeinblue. Danach ist der Knopf wieder normal.
   Ergänzt in der Kopie PMP FUNKTION 1210: Der Preis im festen Kaufbalken folgt immer dem Preis der gewählten Ausführung.
   14.10.2026: Texte kommen übersetzt aus window.PMP.strings (gesetzt in sections/header.liquid). */
(() => {
  'use strict';
  if (window.__pmpKaufknopf) return;
  window.__pmpKaufknopf = true;
  const KNOPF = '.tee-btn--atc, .sticky-atc .btn';
  const TEXT_KNOPF = ((window.PMP&&window.PMP.strings)||{}).kaufBtn || 'Dein Bild wird vorbereitet …';
  const TEXT_MELDUNG = ((window.PMP&&window.PMP.strings)||{}).kaufMsg || 'Einen Moment noch, dein Bild wird gerade vorbereitet.';
  const MUSTER = /wird (gerade )?(hochgeladen|erstellt|verarbeitet|berechnet)|\bBild \d+ von \d+/i;

  const css = document.createElement('style');
  css.textContent =
    '.pmp-busy{position:relative!important;background:#d9d6d0!important;border-color:#d9d6d0!important;box-shadow:none!important;cursor:not-allowed!important;color:transparent!important;opacity:1!important}' +
    '.pmp-busy *{color:transparent!important}' +
    '.pmp-busy::after{content:attr(data-pmp-busy-text);position:absolute;left:0;right:0;top:0;bottom:0;display:flex;align-items:center;justify-content:center;padding:0 .6rem;text-align:center;font-size:.9rem;line-height:1.2;font-weight:600;color:#4a4640}' +
    '.pmp-busy-msg{margin:.55rem 0 0;padding:.6rem .8rem;border-radius:.5rem;background:#f3efe8;color:#4a4640;font-size:.88rem;line-height:1.35}' +
    '.pmp-busy-msg[hidden]{display:none}';
  document.head.appendChild(css);

  const sichtbar = (e) => !!(e.offsetParent || e.getClientRects().length);
  const beschaeftigt = () => {
    if ([...document.querySelectorAll('.pmp-wait')].some((e) => !e.hidden && sichtbar(e))) return true;
    return [...document.querySelectorAll('.tee-campaign *')].some((e) =>
      e.children.length === 0 && MUSTER.test(e.textContent || '') && !e.closest('.pmp-aktion') && sichtbar(e));
  };

  let meldung = null, meldeTimer = null;
  const zeigeMeldung = (knopf) => {
    if (!meldung) {
      meldung = document.createElement('p');
      meldung.className = 'pmp-busy-msg';
      meldung.setAttribute('role', 'alert');
      meldung.textContent = TEXT_MELDUNG;
    }
    const anker = knopf.closest('.tee-form-actions') || knopf.parentElement;
    if (anker && meldung.previousElementSibling !== anker) anker.insertAdjacentElement('afterend', meldung);
    meldung.hidden = false;
    clearTimeout(meldeTimer);
    meldeTimer = setTimeout(() => { if (meldung) meldung.hidden = true; }, 5000);
  };

  // Preis im festen Kaufbalken: immer der Preis, den die gewählte Ausführung zeigt (nicht der beim Laden gerenderte)
  const preisAbgleich = () => {
    const ziel = document.querySelector('[data-sticky-price]');
    const quelle = document.querySelector('.tee-product-price .tee-price--current') || document.querySelector('.tee-product-price');
    if (!ziel || !quelle) return;
    const t = (quelle.textContent || '').replace(/\s+/g, ' ').trim();
    if (t && (ziel.textContent || '').replace(/\s+/g, ' ').trim() !== t) ziel.textContent = t;
  };

  const abgleich = () => {
    preisAbgleich();
    const b = beschaeftigt();
    document.querySelectorAll(KNOPF).forEach((k) => {
      if (b) { k.classList.add('pmp-busy'); k.setAttribute('aria-disabled', 'true'); k.setAttribute('data-pmp-busy-text', TEXT_KNOPF); }
      else { k.classList.remove('pmp-busy'); k.removeAttribute('aria-disabled'); k.removeAttribute('data-pmp-busy-text'); }
    });
    if (!b && meldung) meldung.hidden = true;
  };
  setInterval(abgleich, 400);
  let geplant = false;
  new MutationObserver(() => { if (geplant) return; geplant = true; setTimeout(() => { geplant = false; abgleich(); }, 120); }).observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('click', (e) => {
    const k = e.target && e.target.closest && e.target.closest(KNOPF);
    if (!k || !beschaeftigt()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    zeigeMeldung(k.closest('.tee-form-actions') ? k : (document.querySelector('.tee-btn--atc') || k));
  }, true);
})();
